import './FirmList.scss';
import Component from './FirmList.js';
export default Component;
